import type { SlideProps } from "@/engine/app/offsite-config";
import { EarthSunScene } from "./_earth-scene";

export function Slide06Erdrotation(_: SlideProps) {
  return (
    <div
      className="deck-root dark erdrotation-slide"
      style={{ background: "var(--svo-dunkelblau)" }}
    >
      <div className="deck-bg" aria-hidden="true" />
      <div
        className="float"
        aria-hidden="true"
        style={{
          width: 360,
          height: 360,
          top: "-80px",
          right: "-100px",
          background: "var(--svo-blau)",
          opacity: 0.18,
        }}
      />
      <div
        className="float"
        aria-hidden="true"
        style={{
          width: 260,
          height: 260,
          bottom: "-80px",
          left: "8%",
          background: "var(--svo-gruen)",
          opacity: 0.10,
          animationDelay: "4s",
        }}
      />

      <header className="deck-head">
        <div className="deck-eyebrow rise rise-1">Einschub</div>
        <h1 className="deck-title rise rise-2">
          Eine kurze <br />
          <span className="accent">Geschichte</span>
        </h1>
        <p className="deck-sub rise rise-3">
          Bevor ich das erkläre – ein Moment zum Einordnen.
        </p>
      </header>

      <div className="erdrotation-stage">
        <div className="erdrotation-text">
          <div className="lead-statement rise rise-4">
            Ein Kollege aus dem Team baute eine Erdrotations-Simulation{" "}
            <span className="accent">mit 2 Prompts.</span>
          </div>
          <div className="lead-body rise rise-5">
            Technisch eher pragmatisch unterwegs – wollte seinen Kindern die
            Erdrotation und den Tag-Nacht-Zyklus erklären. Herausgekommen ist
            eine funktionierende, interaktive Simulation. Keine
            Programmierkenntnisse. Kein Tutorial. Zwei Sätze an eine KI.
          </div>
          <div className="lead-pill rise rise-6">
            Wenn das mit zwei Prompts geht – stellt euch vor, was passiert wenn
            man KI-Werkzeuge mit Software-Engineering verbindet.
          </div>
        </div>

        <div className="erdrotation-scene rise rise-5" aria-hidden="false">
          <EarthSunScene />
        </div>
      </div>
    </div>
  );
}
